import React from "react";
import Translate from "react-translate-component";

class Incognito extends React.Component {
  render() {
    const {
      props
    } = this;
    return /*#__PURE__*/React.createElement("div", {
      id: "incognito"
    }, /*#__PURE__*/React.createElement("div", {
      className: "dismiss",
      onClick: props.onClickIgnore
    }, "\xD7"), /*#__PURE__*/React.createElement("strong", null, /*#__PURE__*/React.createElement(Translate, {
      content: "incognito.mode"
    }), " "), /*#__PURE__*/React.createElement(Translate, {
      content: "incognito.warning"
    }));
  }

}

export default Incognito;